import React, { useCallback } from "react";
import Button from "root/components/Button";
import t from "common/i18n";
import { useSelectedAsset } from "../../selectors";
import SVG_ICONS from "~/assets/icons/icons";

export default ({ uploadAsset, inProgress }) => {
	const { selectedFormat } = useSelectedAsset();
	const icon = SVG_ICONS.CLOUD_PLUS;
	const buttonText = t("actions.upload");
	const colorName = "link";

	const purchaseButtonClick = useCallback(() => {
		uploadAsset();
	}, [uploadAsset]);

	return <Button
		text={buttonText}
		disabled={!selectedFormat}
		inProgress={inProgress}
		colorName={colorName}
		icon={icon}
		onClick={purchaseButtonClick}
	/>;
};
